
export default class Jigou {
    public init() {
        this.viewDesc();
    }

    public viewDesc() {
        const $jigouDescBox = $('.p-jigou-d .page-top .desc');
        const $btnSeeAll = $('.btn-see-all');

        $btnSeeAll.on('click',()=>{
            if($jigouDescBox.hasClass('less')){
                $jigouDescBox.removeClass('less');
                $btnSeeAll.text('收起');
            } else {
                $jigouDescBox.addClass('less');
                $btnSeeAll.text('展开查看全部');
            }
        })
    }
}